import React from 'react';
import style from './webhooksExampleIntro.scss';
import { ExamplesPresenter } from '../../../ExamplesPresenter/ExamplesPresenter';
import { EXAMPLE_TYPES } from '../../../../../types';
import { ReactMarkdownDisplay } from '../../../../../../PageElements/ReactMarkdownDisplay';
import { Text } from '../../../../../../PageElements/Text';

export const WebhooksExamplesIntro = ({ eventType = '<event-type>' }) => {
  const hardCodedExample = {
    type: 'json',
    body: [
      '{',
      '  "data": {',
      `    "eventType": "${eventType}",`,
      `    "instanceId": "<app-instance-id>",`,
      `    "data": "<stringified-JSON>"`,
      '  }',
      '}',
    ],
  };
  return (
    <span data-hook="webhooks-examples-intro">
      <Text
        size="small"
        dataHook="webhooks-intro-text-1"
        className={style.text}
      >
        The data payload will include the following as an encoded JWT:
      </Text>
      <div className={style.hardcodedExample} data-hook="hardcoded-example">
        <ExamplesPresenter
          example={hardCodedExample}
          renderFor={EXAMPLE_TYPES.WEBHOOKS_INTRO}
        />
      </div>
      <div data-hook="webhooks-intro-text-2" className={style.text}>
        <ReactMarkdownDisplay
          markdown="The parsed `data` will include:"
          textSize="small"
        />
      </div>
    </span>
  );
};
